import { Button, Card, FormattedMessage, Icon, Tooltip, useIntl } from "@metsooutotec/modes-react-components"
import ListView from "components/utils/list-view/list-view"
import { Site } from "features/organizations/sites/models/sites-models"
import AddressView from "features/organizations/sites/utils/address-view"
import { FC, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import customerStore from "../../store/customer-store"
import { NavigationModalOptions } from "components/utils/modal-helper"
import SiteModal from "features/organizations/sites/components/site-modal"
import styles from "./sites-card.module.css"
import { observer } from "mobx-react-lite"

const SiteSectionCard: FC = observer(() => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()
    const { customerId } = useParams()
    const [siteToEdit, setSiteToEdit] = useState<Site>()
    const [isSiteModalOpen, setSiteModalOpen] = useState(false)
    const { customers } = customerStore
    const customer = customers.find(c => c.id === customerId)
    const sortedSites = customer?.sites?.slice().sort((a, b) => a?.name?.localeCompare(b?.name)) || []

    const template = [
        {
            headingKey: "headings.site",
            cellFunc: (s: Site) => s.name,
        },
        {
            headingKey: "headings.address",
            cellFunc: (s: Site) => <AddressView address={s.address} />,
        },
        {
            headingKey: "headings.contact",
            cellFunc: (s: Site) => s.contact,
        },
        {
            headingKey: "headings.metsoContact",
            cellFunc: (s: Site) => s.metsoContact,
        },
        {
            headingKey: "headings.icon",
            cellFunc: (c: Site) => (
                <Icon name='icon-edit-16' onClick={(event: React.MouseEvent<Element, MouseEvent>) => handleEditSiteIconClick(event, c)} />
            ),
        },
    ]

    const handleEditSiteIconClick = (event: React.MouseEvent, site: Site) => {
        event.stopPropagation()
        setSiteToEdit(site)
        setSiteModalOpen(true)
    }

    const siteModal = {
        open: () => {
            setSiteModalOpen(true)
        },
        close: (passed: boolean, siteId?: string, navigationCustomerOptions?: NavigationModalOptions) => {
            setSiteModalOpen(false)
            setSiteToEdit(undefined)

            if (passed) {
                navigate(`/customers/${customer?.id}/sites/${siteId}`, {
                    state: navigationCustomerOptions,
                })
            }
        },
    }

    if (!customer) return null
    return (
        <>
            <Card
                content={
                    <div className={styles.siteCardContents}>
                        <ListView
                            data={sortedSites}
                            noneYetKey='siteList.noSitesYet'
                            onClickRow={(s: Site) => navigate(`/customers/${customerId}/sites/${s.id}`)}
                            template={template}
                        />
                    </div>
                }
                header={<FormattedMessage id='siteList.title' />}
                rightHeaderItem={
                    <Tooltip
                        content={formatMessage("site.addNew")}
                        data-cy='tooltip'
                        position='top center'
                        small
                        trigger={<Button icon='icon-plus-16' onClick={siteModal.open} subtle primary />}
                    />
                }
            />
            <SiteModal isOpen={isSiteModalOpen} onClose={siteModal.close} site={siteToEdit} customerId={customer.id} />
        </>
    )
})

export default SiteSectionCard
